<template>
  <!--PORTFOLIO MODAL 1 - SWEETX PROJECT -->
  <div
    class="portfolio-modal modal fade"
    id="portfolioModal3"
    tabindex="-1"
    role="dialog"
    aria-labelledby="portfolioModal3Label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <button
          class="close btn btn-outline-light"
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="fas fa-times"></i></span>
        </button>
        <div class="modal-body text-center">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <!-- Portfolio Modal - Title-->
                <h2
                  class="portfolio-modal-title text-secondary text-uppercase mb-5"
                  id="portfolioModal3Label"
                >
                  Trust Technologies Store
                </h2>
                <!-- Portfolio Modal - Image-->
                <img
                  class="img-fluid rounded mb-5"
                  src="../../assets/php-project.png"
                  alt=""
                />
                <!-- Portfolio Modal - Text-->
                <p class="mb-5">
                  As an final requirement for our Advance Web Programming Class.
                  We were tasked to create an e-commerce website. Partnering
                  with
                  <a href="https://github.com/alexcordero">Alex</a>,we have
                  managed to produce a proper e-commerce website using PHP as
                  the back-end.
                  <a href="https://github.com/nimbly-dev/advaprog-proj">link</a>
                  to redirect to the source code.
                </p>
                <button class="btn btn-primary" data-bs-dismiss="modal">
                  <i class="fas fa-times fa-fw"></i>
                  Close Window
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "portfolio-modal-three",
};
</script>

<style>
</style>